const RESTRICTED_LEAD_EMAILS = new Set([
  "xai@xai.com",
  "marcella@marcella.com",
  "rafaelle@rafaelle.com"
]);

const normalizeEmail = (value) => String(value || "").trim().toLowerCase();

const isXaiLeadProfile = (user) =>
  RESTRICTED_LEAD_EMAILS.has(normalizeEmail(user?.email));

export default isXaiLeadProfile;
